import {SHType} from "../common/SHType";

export enum AppPlatformTypeId {
    Web = 1,
    Roku = 2,
    Firetv = 3,
    Appletv = 4,
    Googletv = 5,
    Androidtv = 6,
    Android = 101,
    Ios = 102
}

class _AppPlatformType extends SHType<AppPlatformTypeId> {

    constructor() {
        super(
            "AppPlatformType",
            [
                [AppPlatformTypeId.Web, "web"],
                [AppPlatformTypeId.Roku, "roku"],
                [AppPlatformTypeId.Firetv, "firetv"],
                [AppPlatformTypeId.Appletv, "appletv"],
                [AppPlatformTypeId.Androidtv, "androidtv"],
                [AppPlatformTypeId.Android, "android"],
                [AppPlatformTypeId.Ios, "ios"]
            ]
        );
    }

}

export const AppPlatformType = new _AppPlatformType();



